import { render, staticRenderFns } from "./withdrawBig.vue?vue&type=template&id=740def5e&scoped=true"
import script from "./withdrawBig.vue?vue&type=script&lang=js"
export * from "./withdrawBig.vue?vue&type=script&lang=js"
import style0 from "./withdrawBig.vue?vue&type=style&index=0&id=740def5e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740def5e",
  null
  
)

export default component.exports